import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";

// get productos activos
export const getProductosActivos = async () => {
    const response = await PrivateInterceptor('productos/ProductosActivos', 'GET');
    return response;
}

export const getInventarioProductosExistentes = async () => {
    const result = await PrivateInterceptor('productos/DetalleInventarioProductosExistentes', 'POST');
    return result;
 }

 export const getProductos = async () =>{
    const result = await PrivateInterceptor('productos', 'GET');
    return result;
 }

 export const getProductsNames = async () =>{
    const result = await PrivateInterceptor('productos/ProductsNames', 'GET');
    return result;
 }

 

 
 